import React from 'react'
import AboutList from './aboutlist'
import {Button} from '../../components/common/common'

export default function Address(props){
    return (
        <div className="aboutus-address">
            <ul className="list-unstyled">
                <AboutList name="Email ID" value={props.aboutdata.email} />
                <AboutList name="Address" value={props.aboutdata.address} />
                <AboutList name="Age" value={props.aboutdata.age} />
                <AboutList name="Nationality" value={props.aboutdata.Nationality} />
            </ul>
            <img src={require('../../assets/images/sign.png')} alt="" title="" />
            <Button divclass="allbutton" tagHref="#project" btnClass="btn" spanHover="View Portfolio" btnName="View Portfolio" />
        </div>
    )
}